import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

// Components
import LinkedTitle from "../../utils/titles/LinkedTitle";
import Title from "../../utils/titles/Title";
import ReviewsSearch from "./ReviewsSearch";
import AdminReviewsForm from "./AdminReviewsForm";

class AdminReviewsEdit extends React.PureComponent {
	render() {

		return (
			<React.Fragment>
				{this.props.role === 'manager' 
					? <Title>Reviews</Title>
					: <LinkedTitle link={{ href: "/admin/reviews/add", title: "Create" }}>
						Edit Reviews
					</LinkedTitle>
				}
				
				<Switch>
					<Route path={"/admin/reviews"} exact component={ReviewsSearch} />
					<Route path={"/admin/reviews/edit"} exact component={ReviewsSearch} />
					<Route path={"/admin/reviews/edit/:id"} component={AdminReviewsForm} />
				</Switch>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		role: state.user.admin.user.role
	};
};

export default connect(mapStateToProps)(AdminReviewsEdit);


// WEBPACK FOOTER //
// ./src/components/admin/reviews/AdminReviewsEdit.js